module.exports = __webpack_public_path__ + "static/pic15-10ad8dd43ed86bf9dff554dfb99c0cb1.jpg";